import { gql } from "@apollo/client";

export const GET_ACCOUNT_INCOME_DASHBOARD = gql`
  query Query($incomType: String!) {
    getAccountIcomeDashboard(incomType: $incomType)
  }
`;

export const GET_OTHERS_INCOME_DASHBOARD = gql`
  query Query {
    getOtherIcomeDashboard
  }
`;

export const GET_TOTAL_INCOME_BY_YEAR = gql`
  query Query($academicYearId: ID) {
    getTotalIncomeByYear(academicYearId: $academicYearId)
  }
`;

export const GET_TODAY_INCOME = gql`
  query Query {
    todayIncome
  }
`;

export const GET_TOTAL_STUDENT_OF_SERVICE_TO_TPAY = gql`
  query Query($academicYearId: ID!) {
    totalStudentOfServiceToPayToday(academicYearId: $academicYearId)
  }
`
export const GET_TOTAL_AMOUT_TO_PAY_TODAY = gql`
  query Query($academicYearId: ID!) {
    totalAmountOfServiceToPayToday(academicYearId: $academicYearId)
  }
`

export const GET_INCOME_BY_INCOME_TYPE = gql`
  query GetIncomeByIncomeType($date: String!) {
    getIncomeByIncomeType(date: $date) {
      incomeType
      totalAmount
    }
  }
`;

export const GET_DIALY_INCOME_CHART = gql`
  query GetDailyIncomeChart($academicYearId: ID) {
    getDailyIncomeChart(academicYearId: $academicYearId) {
      label
      value
    }
  }
`
